export default __webpack_public_path__ + "static/media/close-outline.121e02b1.svg";